const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/eCheckin/sections/HausArzt.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { ArztBlock, ArztFieldsConfig } from 'App/components/eCheckin/components/fields/ArztBlock';
import { createFieldPath, fieldValueIsNot } from 'App/components/eCheckin/utils';
import { AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { useText } from '@cistec/common_web/utils/intlUtils';

const arztFieldsConfig: ArztFieldsConfig = {
    tel: {
        included: false,
    },
};
const addressFieldsConfig: AddressFieldsConfig = {
    country: {
        included: false,
    },
    additionalInfo: {
        included: false,
    },
};

export const HausArzt = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_KEIN_HAUSARZT = createFieldPath(path, 'keinHausarzt');

    const eCheckinSectionRef = useCIS4m(ref);

    const formData = useCIS4mData();
    const hasKeinHausarzt = !fieldValueIsNot(formData, PATH_KEIN_HAUSARZT, ['1']);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.keinHausarzt} path={PATH_KEIN_HAUSARZT} />
            <ArztBlock
                basePath={path}
                hidden={hasKeinHausarzt}
                required={true}
                readonly={true}
                fieldsConfig={arztFieldsConfig}
                addressFieldsConfig={addressFieldsConfig}
            />
        </ECheckinSection>
    );
});

HausArzt.displayName = 'HausArzt';

export default HausArzt;
